module.exports = __webpack_public_path__ + "img/headerBanner.361361ac.png";